import React from 'react'

import { usd } from './importFormStyles'

interface ScoreCardProps {
  label: string
  value: number
  color: string
  sub?: string
}

export const ScoreCard = ({ label, value, color, sub }: ScoreCardProps) => (
  <div style={{
    flex: 1, padding: '10px 12px', borderRadius: 8,
    border: '1px solid #e5e7eb', borderTop: `3px solid ${color}`,
  }}>
    <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4 }}>{label}</div>
    <div style={{ fontSize: 15, fontWeight: 700, color, lineHeight: 1.2 }}>{usd.format(value)}</div>
    {sub && <div style={{ fontSize: 10, color: '#9ca3af', marginTop: 2 }}>{sub}</div>}
  </div>
)
